import { s } from "@kosmod/pancake";

export type Die = {
  name: string,
  sides: number,
}
export const Die = s.o({
  name: s.str,
  sides: s.num,
})

export const STANDARD_DICE: Die[] = [
  { name: 'd4', sides: 4 },
  { name: 'd6', sides: 6 },
  { name: 'd8', sides: 8 },
  { name: 'd10', sides: 10 },
  { name: 'd12', sides: 12 },
  { name: 'd20', sides: 20 },
]

export type DiceExpression =
  | { type: 'die', count: number, die: Die }
  | { type: 'bin-op', operation: 'add' | 'subtract' | 'multiply' | 'divide', left: DiceExpression, right: DiceExpression }
  | { type: 'const', value: number }
  


export const DiceExpressionData = s.o({
  
})


export type DiceResult = {
  value: number,
}
export const DiceResult = s.o({
  value: s.num,
})
